import React from 'react';
import TNAPivotTable from './TNAPivotTable';

function TNADashboard() {
    return (
        <div className="h-[calc(100vh-100px)] flex flex-col overflow-hidden px-[10px]">
            <div className="flex-1 overflow-hidden pl-[15px] pt-[15px]">
                {/* `data` is the fallback dataset used until the backend response arrives —
                    TNAPivotTable fetches its own headers/data via Redux and switches to that
                    as soon as it lands. */}
                <TNAPivotTable />
            </div>
        </div>
    );
}

export default TNADashboard;
